export interface QuoteCommitment {
  market: string;
  minimum_side_notional_usd: string;
  minimum_option_strikes_per_expiry?: number;
  utc_windows: {
    weekday: number;
    start_minute: number;
    end_minute: number;
  }[];
}

export function quoteWindow(window: QuoteCommitment["utc_windows"][number]) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const clock = (minute: number) =>
    `${Math.floor(minute / 60)
      .toString()
      .padStart(2, "0")}:${(minute % 60).toString().padStart(2, "0")}`;
  return `${days[window.weekday]} ${clock(window.start_minute)}–${clock(
    window.end_minute
  )} UTC`;
}

export function optionCoverage(commitment: QuoteCommitment) {
  if (!["BTC-OPTIONS", "ETH-OPTIONS"].includes(commitment.market))
    return "Not applicable";
  if (commitment.minimum_option_strikes_per_expiry === undefined)
    return "Not recorded";
  return `${commitment.minimum_option_strikes_per_expiry} strikes per expiry · calls and puts`;
}
